import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getToken } from './services/api';
import Login from './pages/Login';
import Fila from './pages/Fila';
import Conversa from './pages/Conversa';
import PainelGerente from './pages/PainelGerente';

function ProtectedRoute({ children }) {
  return getToken() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/fila" element={<ProtectedRoute><Fila /></ProtectedRoute>} />
        <Route path="/conversa/:id" element={<ProtectedRoute><Conversa /></ProtectedRoute>} />
        <Route path="/gerente" element={<ProtectedRoute><PainelGerente /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
